import { buildAnimation, getHeight, fireCustomEvent, afterRepaint, isMovingBackward, flip } from './utils';
import defaultOptions from './defaultOptions';
function Steppp(element, options = defaultOptions) {
    const getStep = (stepIndex = getActiveStepIndex()) => {
        return steps[stepIndex];
    };
    const getStepByName = (stepName = "") => {
        return steps.find(step => step.dataset.stepppName === stepName);
    };
    const getActiveStepIndex = () => {
        return steps.findIndex(step => step.dataset.stepppActive !== undefined) || 0;
    };
    const moveTo = (stepName) => {
        moveStep({ stepName });
    };
    const forward = () => {
        moveStep();
    };
    const backward = () => {
        moveStep({ direction: 'backward' });
    };
    const animate = (args) => {
        args.options = {};
        return buildAnimation(args);
    };
    const queueAnimations = (oldStep, newStep, direction) => {
        const backward = isMovingBackward(direction);
        const { enter, exit } = animationFrames;
        const oldStepHeight = `${currentWrapperHeight}px`;
        const newStepHeight = `${calculateWrapperHeight(newStep)}px`;
        return [
            animate({
                frames: backward ? flip(exit) : exit,
                targetElement: backward ? newStep : oldStep
            }),
            animate({
                frames: backward ? flip(enter) : enter,
                targetElement: backward ? oldStep : newStep
            }),
            animate({
                frames: [
                    {
                        height: oldStepHeight,
                    },
                    {
                        height: newStepHeight
                    }
                ],
                targetElement: stepWrapper
            })
        ];
    };
    const moveStep = async ({ stepName = "", direction = 'forward' } = {}) => {
        const fallbackIncrementor = direction === 'forward' ? 1 : -1;
        const oldActiveStep = getStep();
        const newActiveStep = getStepByName(stepName) || getStep(getActiveStepIndex() + fallbackIncrementor);
        heightObserver.unobserve(oldActiveStep);
        if (currentAnimations.length) {
            currentAnimations.map(a => a.finish());
        }
        afterRepaint(async () => {
            const eventArgs = {
                oldStep: oldActiveStep,
                newStep: newActiveStep,
                element
            };
            if (direction === 'forward' && !(await stepIsValid(getStep()))) {
                return fireCustomEvent({
                    ...eventArgs,
                    name: "steppp:invalid"
                });
            }
            if (!newActiveStep) {
                return fireCustomEvent({
                    ...eventArgs,
                    name: "steppp:abort"
                });
            }
            fireCustomEvent({
                ...eventArgs,
                name: "steppp:start"
            });
            afterRepaint(async () => {
                currentAnimations = queueAnimations(oldActiveStep, newActiveStep, direction);
                await Promise.all(currentAnimations.map(a => a.finished));
                currentAnimations = [];
                oldActiveStep.style.display = "none";
                delete oldActiveStep.dataset.stepppActive;
                newActiveStep.dataset.stepppActive = "";
                heightObserver.observe(newActiveStep);
                fireCustomEvent({
                    ...eventArgs,
                    name: "steppp:complete"
                });
            });
        });
    };
    const calculateWrapperHeight = (step) => {
        step.style.display = "block";
        const newHeight = getHeight(step);
        currentWrapperHeight = newHeight;
        return newHeight;
    };
    const computeAnimationFrames = (frames) => {
        if (Array.isArray(frames)) {
            return {
                enter: frames,
                exit: [...frames.slice()].reverse()
            };
        }
        return frames;
    };
    const stepWrapper = (element.querySelector('[data-steppp-wrapper]') || element);
    const mergedOptions = { ...defaultOptions, ...options };
    const { stepIsValid, frames } = mergedOptions;
    const steps = Array.from(stepWrapper.children);
    const animationFrames = computeAnimationFrames(frames);
    let currentAnimations = [];
    getStep().style.position = 'absolute';
    let currentWrapperHeight = getHeight(getStep());
    stepWrapper.style.height = `${currentWrapperHeight}px`;
    const heightObserver = new ResizeObserver(() => {
        calculateWrapperHeight(getStep());
        stepWrapper.style.height = `${currentWrapperHeight}px`;
    });
    heightObserver.observe(getStep());
    element.querySelectorAll('[data-steppp-backward]').forEach(el => {
        el.addEventListener('click', backward);
    });
    element.querySelectorAll('[data-steppp-forward]').forEach(el => {
        el.addEventListener('click', forward);
    });
    element.querySelectorAll('[data-steppp-to]').forEach(el => {
        el.addEventListener('click', () => {
            moveTo(el.dataset.stepppTo || "");
        });
    });
    return {
        backward,
        forward,
        moveTo
    };
}
export default Steppp;
